import React from 'react'
import {Helmet} from "react-helmet"
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import ReviewsSlider from './ReviewsSlider'
import ReviewsBoxes from './ReviewsBoxes'
import PlayMedia from '~/core/components/PlayMedia'
import { renderRoutes } from 'react-router-config'
import { fetchReviewIfNeeded, resetActiveReview, fetchReviewsIfNeeded, fetchAlbumsIfNeeded, fetchPodcastsIfNeeded } from '~/reviews/actions'
import ImageSlider from '~/core/components/ImageSlider'

const ReviewBox = (props) => {
  const {item} = props;
  item.path = item.path.replace(/.*\/reviews\/(\w+)\/(.*)/g, "$1/$2")
  let image = item.field_review_live_image ? item.field_review_live_image : item.field_review_arts_image ? item.field_review_arts_image : item.field_review_book_image ? item.field_review_book_image : item.field_review_movie_image ? item.field_review_movie_image : item.field_review_game_image
  return (
    
    <div className={ (item.sticky === 'True' ?  'sticky ' : '')+  'review-box' }>
      <Link
        key={item.nid[0].value}
        to={{
        pathname: `/reviews/${item.path}`,
        // this is the trick!
        state: { modal: true, data: item }
      }}>
      <div>
        <h4>{item.type}</h4>
        <div className="cover-image" style={{ backgroundImage: 'url("//jeff.4zzz.org.au/' + image + '")' }} />
        <h3>{item.title}</h3>
        <div dangerouslySetInnerHTML={ { __html: item.body } } />
        </div>
      </Link>
    </div>
  )
}


const Review = (props) => {
  const { review } = props
  if ( review && review.title) {
  var type = review.type.map((item) => ( item.target_id.replace('review_', '') ))[0]
  var worsemarkup = '<p>' + review.body[0].value.replace(/\n\s*\n/g, '</p>\n\n<p>') + '</p>'
  var badmarkup = { __html: worsemarkup }
  return (
    <React.Fragment>
      <h2>{type.replace(/^\w/, (c) => c.toUpperCase())} Review</h2>
      <div>

      <div className="review">
        <Helmet>
          <title>{review.title[0].value}</title>
          <meta name="description" content={review['field_review_'+ type +'_teaser'][0].value.replace(/<[^>]+>/g, '') } />
          <meta name="og:description" content={review['field_review_'+ type +'_teaser'][0].value.replace(/<[^>]+>/g, '') } />
          <meta property="og:title" content={review.title[0].value} />
          <meta property="og:image" content={review['field_review_'+ type +'_image'][0].url } />
          <meta property="og:type" content="article" />
        </Helmet>
        <h2 class="title">{review.title[0].value}</h2>

        <div className="art">
          { (review['field_review_'+ type +'_image'] && review['field_review_'+ type +'_image'].length > 1) ?
              <ImageSlider style={{height: '600px'}} data={ review['field_review_'+ type +'_image']} />
            : <img src={ review['field_review_'+ type +'_image'][0].url } />
           }
        </div>
        <div  className="body" dangerouslySetInnerHTML={badmarkup} />
      </div>
    </div>
    </React.Fragment>

  )
  }
  else {
  return null
}
}


class Reviews extends React.Component {

  constructor() {
    super();
    this.state = {
      data: [],
      podcasts: [],
      albums: []
    }
  }

  static fetchData(store, route, match) {
    if(match.params.id) {
      return Promise.all([
        store.dispatch(fetchReviewIfNeeded(match.params.type, match.params.id)),
        store.dispatch(fetchReviewsIfNeeded(0)),
        store.dispatch(fetchAlbumsIfNeeded(0)),
        store.dispatch(fetchPodcastsIfNeeded(0))
      ])
    }
    return Promise.all([
      store.dispatch(fetchReviewsIfNeeded(0)),
      store.dispatch(fetchAlbumsIfNeeded(0)),
      store.dispatch(fetchPodcastsIfNeeded(0))
    ])
  }

  componentWillReceiveProps(newProps) {
    const { match, history, dispatch } = newProps
    if(this.props.match.params.id != match.params.id ) {
      if(match.params.id ) {

        dispatch(fetchReviewIfNeeded(match.params.type, match.params.id))
        document.querySelector('.reviews').scrollIntoView()
      } else {
        dispatch(resetActiveReview())
      }
    }
  }

  componentDidMount() {
    this.getReviews()
    const { match, history, dispatch } = this.props
    if(match.params.id ) {
      document.body.scrollTop = 0
      dispatch(fetchReviewIfNeeded(match.params.type, match.params.id))
    }
  }

  getReviews() {
    const { dispatch } = this.props
    dispatch(fetchReviewsIfNeeded(0))
    dispatch(fetchAlbumsIfNeeded(0))
    dispatch(fetchPodcastsIfNeeded(0))
  }

  render() {
    const { albums, reviews, podcasts, route } = this.props

    const Podcasts = podcasts.items.map((podcast, index) => {
      var result = "<p>" + podcast.body[0].value + "</p>";
      result = result.replace(/\r\n\r\n/g, "</p><p>").replace(/\n\n/g, "</p><p>");
      result = result.replace(/\r\n/g, "<br />").replace(/\n/g, "<br />");
      var badmarkup = { __html: result  };

      let image = podcast.field_cultural_package_image && podcast.field_cultural_package_image[0] ?
         podcast.field_cultural_package_image[0].url : podcast.field_music_package_image &&  podcast.field_music_package_image[0] ?   podcast.field_music_package_image[0].url : null
      return(
        <div className="podcast" key={index}>
          <div className="cover-image" style={{ backgroundImage: 'url(' + image + ')' }}>
            <PlayMedia media={( podcast.field_cultural_package_file ?
               podcast.field_cultural_package_file[0].url : podcast.field_music_package_file ?   podcast.field_music_package_file[0].url : null )} />
          </div>

          <h3>{podcast.title[0].value}</h3>
          {/* <div className="description" dangerouslySetInnerHTML={ badmarkup } /> */}

        </div>
      )
    })

    const Albums = albums.items.sort((a,b) => b.sticky.localeCompare(a.sticky) ).map((item, index) => {
      if(index < 9) {
          return(
            <div key={index} className={item.sticky === 'True' ? 'sticky' : ''}>
             <Link to={item.path}>
              <img src={ '//jeff.4zzz.org.au/' + item.field_review_image} />
              <div className="release-artist"><strong>{item.field_review_album_artist}</strong></div>
              <div className="release-title">{item.field_review_album_title}</div>
              {item.sticky === 'True' && <div className="release-summary">{item.body}</div>}
            </Link>
           </div> 
          )
      }
    })


    return (

      <div className="reviews">

        {reviews.reviews.active && 
          <div className="content">
            <Review review={reviews.reviews[reviews.reviews.active]} /> 
          </div>
        }

        {!reviews.reviews.active &&
          <div className="content">
            <h2>New Releases</h2>
            <div style={{padding: '18px'}} className="review-albums">{Albums}</div>
            <div className="nrs"><img src="/assets/crate-digging.png" /><p>Keep up to date with all the latest records worth talking about with 4ZZZ's weekly review show <em>The New Releases Show</em>. Producer and host Chris Cobcroft will guide you through all the hits and misses on the record stands with regular contributions from Zed's family of announcers, music department volunteers and alumni. Recorded at 4ZZZ's studios and broadcast every Friday at 3PM or <Link to="/program/the-new-releases-show">available anytime ondemand.</Link></p></div>
          </div>
        }

        <div className="content">
          <h2>Reviews</h2>
          <div className="review-boxes">
            
            {this.props.reviews.items.sort((a,b) => b.sticky.localeCompare(a.sticky) ).map((i,n) => <ReviewBox item={i} />) }
          </div>
        </div>
        <div className="content podcasts">
          <h2>Quick Listens</h2>
          <div>{Podcasts}</div>
        </div>
        {renderRoutes(route.routes, { someProp: 'these extra props are optional' })}
      </div>
    )
  }
}

export default connect(state => { return { reviews: state.reviews, albums: state.albums, podcasts: state.podcasts } } ) (Reviews)
